import Image from 'next/image';
import type { ImageIconProps } from './types';

export const IconGoogle = ({ width, height, className }: ImageIconProps) => {
  return (
    <Image
      src='/images/ui/icons/google.svg'
      width={width}
      height={height}
      alt='Google'
      className={className}
    />
  );
};
